import React, { FC } from 'react';
import classNames from 'classnames';
import {
  Asset,
  AssetProps,
  UserOutlineIcon,
  VehicleOutlineIcon,
  ShieldOutlineIcon,
  MapMarkerIcon,
  PhoneOutlineIcon,
} from '@clearcover/atlas';
import styles from './styles.module.css';

export type EntityIconProps = {
  className?: string;
  variant: 'driver' | 'vehicle' | 'coverage' | 'marker' | 'phone';
};

const iconMap: Record<EntityIconProps['variant'], AssetProps['icon']> = {
  driver: UserOutlineIcon,
  vehicle: VehicleOutlineIcon,
  coverage: ShieldOutlineIcon,
  marker: MapMarkerIcon,
  phone: PhoneOutlineIcon,
};

export const EntityIcon: FC<EntityIconProps> = ({ className, variant }) => {
  return (
    <div className={classNames(styles.wrapper, styles[variant], className)}>
      <Asset
        className={styles.icon}
        icon={iconMap[variant]}
        description={`${variant}-icon`}
        height={24}
        width={24}
      />
    </div>
  );
};
